<template>
  <div class="list-common-buttons">
    <div
      class="list-common-buttons-item"
      @click="v.onClick"
      v-for="(v, i) in btns"
      :key="i"
      v-stat="v.stat"
    >
      {{ v.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    btns: {
      type: Array
    }
  }
}
</script>

<style lang="scss">
.list-common-buttons {
  display: flex;
  box-shadow: 0 -15px 30px #f5f8ff;

  &-item {
    flex: 1;
    font-size: 28px;
    font-weight: bold;
    line-height: 1.25px;
    height: 108px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #6982fa;
    position: relative;
    &:not(:nth-last-child(1)) {
      color: #9da3ac;

      &:after {
        position: absolute;
        right: 0;
        height: 40px;
        margin-top: -20px;
        top: 50%;
        content: '';
        border-right: 1px solid #f3f4f5;
      }
    }
  }
}
</style>
